/* Printado – minimale JS: variantkeuze, AJAX winkelwagen, galerij, filters. */
(function () {
  'use strict';
  var money = function (cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
  };

  function initProduct(section) {
    var dataEl = section.querySelector('[data-variants]');
    var form = section.querySelector('[data-product-form]');
    if (!dataEl || !form) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = section.querySelector('[data-price] .price__now');
    var errEl = form.querySelector('[data-error]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('.opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    var unitEl = section.querySelector('[data-unit]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    function updateUnit(v, sel) {
      if (!unitEl) return;
      var legends = form.querySelectorAll('.opt legend');
      var qty = 0;
      legends.forEach(function (lg, i) {
        if (/oplage|aantal/i.test(lg.textContent)) qty = parseInt(sel[i], 10) || 0;
      });
      if (v && qty > 1) {
        unitEl.textContent = money(Math.round(v.price / qty)) + ' per stuk';
        unitEl.hidden = false;
      } else { unitEl.hidden = true; }
    }
    var matrixEl = section.querySelector('[data-matrix]');
    var matrixBody = section.querySelector('[data-matrix-body]');
    function buildMatrix() {
      if (!matrixEl || !matrixBody) return;
      var fsets = form.querySelectorAll('.opt');
      var qi = -1;
      fsets.forEach(function (fs, i) {
        if (/oplage|aantal/i.test(fs.querySelector('legend').textContent)) qi = i;
      });
      if (qi < 0) { matrixEl.hidden = true; return; }
      var sel = selected();
      var rows = variants.filter(function (v) {
        return v.options.every(function (o, i) { return i === qi || sel[i] === null || sel[i] === o; });
      }).sort(function (a, b) { return (parseInt(a.options[qi], 10) || 0) - (parseInt(b.options[qi], 10) || 0); });
      if (rows.length < 2) { matrixEl.hidden = true; return; }
      matrixBody.innerHTML = '';
      rows.forEach(function (v) {
        var q = parseInt(v.options[qi], 10) || 1;
        var tr = document.createElement('tr');
        if (sel[qi] === v.options[qi]) tr.className = 'is-active';
        tr.tabIndex = 0;
        tr.innerHTML = '<td>' + v.options[qi] + '</td><td>' + money(v.price) + '</td><td>' + money(Math.round(v.price / q)) + '</td>';
        var pick = function () {
          var input = fsets[qi].querySelector('input[value="' + v.options[qi].replace(/"/g, '\\"') + '"]');
          if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        };
        tr.addEventListener('click', pick);
        tr.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
        matrixBody.appendChild(tr);
      });
      matrixEl.hidden = false;
    }
    function update() {
      var sel = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return sel[i] === null || sel[i] === o; });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Niet beschikbaar'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      updateUnit(v, sel);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      if (v.featured_image) {
        var img = section.querySelector('#product-main-image');
        if (img && v.featured_image.src) { img.src = v.featured_image.src; img.removeAttribute('srcset'); }
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
    buildMatrix();
    (function initUnit() {
      var sel = selected();
      var v = variants.find(function (x) { return String(x.id) === idInput.value; });
      updateUnit(v, sel);
    })();

    var sticky = section.querySelector('[data-sticky]');
    var stickyBtn = section.querySelector('[data-sticky-btn]');
    if (sticky && stickyBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var ok = form.querySelector('[data-upload-ok]');
      if (ok && !ok.checked) {
        errEl.textContent = 'Bevestig eerst dat je je ontwerp hebt gecontroleerd.';
        errEl.hidden = false;
        ok.focus();
        return;
      }
      addBtn.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Toevoegen mislukt');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          var t = document.getElementById('cart-toast');
          if (t) { t.hidden = false; setTimeout(function () { t.hidden = true; }, 6000); }
        })
        .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
        .finally(function () { addBtn.disabled = false; });
    });

    section.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = section.querySelector('#product-main-image');
        if (img) { img.src = b.getAttribute('data-thumb'); img.removeAttribute('srcset'); }
        section.querySelectorAll('[data-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  function initFilters() {
    var f = document.getElementById('collection-filters');
    if (f) f.addEventListener('change', function () { f.submit(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initFilters();
  });
})();

/* Voorbeeld van het geüploade ontwerp op de productpagina */
(function () {
  function init(section) {
    var box = section.querySelector('.upload');
    if (!box) return;
    var panel = box.querySelector('[data-upload-preview]');
    var gallery = section.querySelector('.gallery__main');
    var overlay = null, url = null;

    function clear() {
      if (url) { URL.revokeObjectURL(url); url = null; }
      if (overlay) { overlay.remove(); overlay = null; }
      panel.hidden = true; panel.innerHTML = '';
    }
    function fmt(n) { return n > 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.round(n / 1024) + ' KB'; }
    function show(src, name, size, isImg) {
      panel.hidden = false;
      panel.innerHTML = '';
      var head = document.createElement('div'); head.className = 'upload__pv-head';
      var t = document.createElement('strong'); t.textContent = 'Voorbeeld van jouw ontwerp';
      var x = document.createElement('button'); x.type = 'button'; x.className = 'upload__pv-x'; x.textContent = 'Verwijderen'; x.setAttribute('data-pv-clear', '');
      head.appendChild(t); head.appendChild(x); panel.appendChild(head);
      var info = document.createElement('p'); info.className = 'upload__pv-info';
      info.textContent = name + (size ? ' · ' + fmt(size) : '');
      if (isImg) {
        var img = new Image(); img.alt = 'Voorbeeld van jouw ontwerp'; img.className = 'upload__pv-img';
        img.onload = function () {
          info.textContent += ' · ' + img.naturalWidth + ' × ' + img.naturalHeight + ' px';
          if (Math.max(img.naturalWidth, img.naturalHeight) < 1000) {
            var w = document.createElement('p'); w.className = 'upload__pv-warn';
            w.textContent = 'Let op: dit bestand heeft een lage resolutie en kan er vaag uitzien in druk.';
            panel.appendChild(w);
          }
        };
        img.src = src; panel.appendChild(img); panel.appendChild(info);
        if (gallery) {
          if (overlay) overlay.remove();
          overlay = document.createElement('div'); overlay.className = 'gallery__design';
          var o = new Image(); o.src = src; o.alt = ''; overlay.appendChild(o);
          var tag = document.createElement('span'); tag.textContent = 'Voorbeeld, niet op schaal'; overlay.appendChild(tag);
          gallery.appendChild(overlay);
        }
      } else {
        var f = document.createElement('p'); f.className = 'upload__pv-file'; f.textContent = 'Bestand geselecteerd (geen afbeeldingsvoorbeeld voor dit bestandstype)';
        panel.appendChild(f); panel.appendChild(info);
      }
    }
    function fromFile(file) {
      if (!file) return;
      if (url) URL.revokeObjectURL(url);
      var isImg = /^image\/(png|jpe?g|gif|webp|svg\+xml)$/.test(file.type);
      url = isImg ? URL.createObjectURL(file) : null;
      show(url, file.name, file.size, isImg);
    }

    /* 1. rechtstreekse bestandsvelden (change bubbelt tot document) */
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.type === 'file' && box.contains(el) && el.files && el.files[0]) fromFile(el.files[0]);
    }, true);
    /* 2. slepen naar het uploadblok */
    box.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) fromFile(f);
    }, true);
    /* 3. apps die zelf een afbeelding tonen (bijv. na de upload): spiegel die */
    var app = box.querySelector('.upload__app');
    if (app && window.MutationObserver) {
      new MutationObserver(function () {
        if (!panel.hidden) return;
        var im = app.querySelector('img[src]');
        if (im && im.src && im.naturalWidth > 40) show(im.src, 'Geüpload bestand', 0, true);
      }).observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    panel.addEventListener('click', function (e) { if (e.target.hasAttribute('data-pv-clear')) clear(); });
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(init);
  });
})();
